export default "__VITE_ASSET__c9fe6441__"